import React from 'react'
import { RewardsHubTab } from '@/api/Trading-Accounts/Types/RewardsHubDto'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabNavigate } from 'hooks/useTabNavigate'

interface Props {
  tab: RewardsHubTab
}

export const RewardsHubNavigation: React.FC<Props> = (props) => {
  const tabNavigate = useTabNavigate()

  return (
    <Tabs value={props.tab} onValueChange={tabNavigate} className='mt-2'>
      <TabsList>
        <TabsTrigger value={RewardsHubTab.MANAGER}>Reward Type Manager</TabsTrigger>
        {/*<TabsTrigger value={RewardsHubTab.PROGRAMS}>Reward Programs</TabsTrigger>*/}
      </TabsList>
    </Tabs>
  )
}
